import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'

import Emulsion from '@/components/landing/emulsion/Emulsion'

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Ines Vahl'
                description='A photographer of unhurried light — a wall of prints you pan across.'
            />

            <main className='h-dvh w-full overflow-hidden'>
                <Emulsion />
            </main>
        </>
    )
}

export default Home
